import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
const tableData = [{
  method: 'Otros métodos',
  this: 'Este Megapack'
}, {
  method: 'Atacan solo la dieta',
  this: 'Trabaja intestino + nervios + energía juntos'
}, {
  method: 'Requieren equipamiento o gym',
  this: 'Todo desde tu casa con ingredientes del súper'
}, {
  method: 'Lenguaje médico complicado',
  this: 'Directo, claro, "de mujer a mujer"'
}, {
  method: 'Resultados en meses',
  this: 'Primeros cambios en 72 horas'
}, {
  method: 'Caros y difíciles de sostener',
  this: 'Accesible para el presupuesto argentino real'
}, {
  method: 'Te dejan sola con la información',
  this: 'Checklists diarios paso a paso'
}];
export function KitScale() {
  return <section className="py-20 bg-brand-card border-y border-brand-border" data-id="element-208">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-209">
        <FadeIn className="text-center mb-16" data-id="element-210">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-211">
            ⚖️ ¿POR QUÉ FUNCIONA?
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} className="overflow-x-auto" data-id="element-212">
          <table className="w-full text-left border-collapse min-w-[700px] bg-brand-cream rounded-2xl overflow-hidden border border-brand-border" data-id="element-213">
            <thead data-id="element-214">
              <tr className="border-b border-brand-border bg-brand-card" data-id="element-215">
                <th className="p-5 text-brand-dark font-bold w-1/2" data-id="element-216">
                  ❌ Otros métodos
                </th>
                <th className="p-5 text-brand-accent font-bold w-1/2" data-id="element-217">
                  ✅ Este Megapack
                </th>
              </tr>
            </thead>
            <tbody data-id="element-218">
              {tableData.slice(1).map((row, i) => <tr key={i} className="border-b border-brand-border hover:bg-brand-card/50 transition-colors" data-id="element-219">
                  <td className="p-5 text-brand-muted" data-id="element-220">{row.method}</td>
                  <td className="p-5 text-brand-dark font-medium" data-id="element-221">
                    {row.this}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </FadeIn>
      </div>
    </section>;
}